import type { FC } from "react";

import { isNumber } from "lodash";
import styled from "styled-components";

import { abbrNumberFilter } from "app/filters/ngFilters";
import { CoreConditionCellRightAlign } from "pro-features/components/core cells/src/CoreConditionCell/CoreConditionCell";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const MONTHLY_DATA_THRESHOLD = 100;

const Text = styled.div`
    margin-left: 8px;
`;

interface IVisitsThreshHoldCell {
    value: number;
}

/**
 * @deprecated Use `renderAbbrNumberWithThresholdCellFactory` from `components/table`
 */
export const VisitsThreshHoldCell: FC<IVisitsThreshHoldCell> = ({ value }) => {
    const formatValue = abbrNumberFilter()(value);

    return (
        <CoreConditionCellRightAlign
            value={formatValue || "N/A"}
            Component={<ComponentWithSmallTraffic />}
            condition={isNumber(value) ? value < MONTHLY_DATA_THRESHOLD : false}
        />
    );
};

const ComponentWithSmallTraffic = () => {
    return (
        <FlexRow>
            <Text> {`< ${MONTHLY_DATA_THRESHOLD}`} </Text>
        </FlexRow>
    );
};
